@if (details().error) {
    <div class="text-large leading-relaxed mb-3 text-red">{{ details().error }}</div>
} @else {
    <div class="text-large leading-relaxed mb-3">
        <div class="mt-2">Updates for <span class="text-bold">{{details().name}}</span>:</div>
        @if (details().edited_attributes.length) {
            <div class="mt-2">
                <span class="text-bold">Updating:</span>
                <ul class="mt-1 mb-0">
                    @for (attribute of details().edited_attributes; track attribute[0]) {
                        <li>
                            <span class="text-bold">{{ humanizeAttribute(attribute[0]) }}:</span>
                            {{ attribute[1] }}
                        </li>
                    }
                </ul>
            </div>
        }
        @if (details().new_holdings_list.length) {
            <div class="mt-2">
                <span class="text-bold">New holdings list after update:</span>
                <ul class="mt-1 mb-0">
                    @for (holding of details().new_holdings_list; track holding[0]) {
                        <li><span class="text-bold">{{ holding[0] }}</span>: {{ holding[1] }}</li>
                    }
                </ul>
            </div>
        }
        @if (!details().edited_attributes.length && !details().new_holdings_list.length) {
            <div>No changes proposed.</div>
        }
    </div>
}
